import React from 'react'
import styled from 'styled-components'
import NeedItem from './NeedItem'
import { PopulatedResidentNeed } from '../../../../hooks/useCarePlanPopulated'

interface NeedsListProps {
  items: PopulatedResidentNeed[]
  disabled?: boolean
  lastReviewDate?: string
  onRemove?: (needId: string) => void
  testId?: string
}

const NeedsList: React.FC<NeedsListProps> = ({
  items,
  disabled = false,
  lastReviewDate,
  onRemove,
  testId
}) => {
  if (!items?.length) {
    return null
  }

  return (
    <Wrapper data-testid={testId}>
      <ItemsWrapper>
        {items.map((item, index) => (
          <NeedItem
            key={item.id}
            need={item}
            disabled={disabled}
            lastReviewDate={lastReviewDate}
            onRemove={onRemove}
            testId={testId ? `${testId}-row-${index}` : undefined}
          />
        ))}
      </ItemsWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export default NeedsList
